// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServiceAttributes_AtributosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/additional_service_attributes/atributos/{additional_service_id}
 *
 * Returns the attribute bindings (with nested options for `select` types)
 * configured for the given additional service. Legacy `dados` shape is a
 * list, so getDados() returns the array directly.
 */
import type { AdditionalServiceAttributes_BindingRow } from './AdditionalServiceAttributes_BindingRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type AdditionalServiceAttributes_AtributosResponseDados = AdditionalServiceAttributes_BindingRow[];

export type AdditionalServiceAttributes_AtributosResponse = ApiResponse<AdditionalServiceAttributes_AtributosResponseDados>;

registerResponseContract('AdditionalServiceAttributes_AtributosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_asal_id:                    { type: 'number',  required: true },
      so_asal_additional_service_id: { type: 'number',  required: true },
      so_asal_attribute_id:          { type: 'number',  required: true },
      so_asal_required:              { type: 'number',  required: true },
      so_asal_display_order:         { type: 'number',  required: true },
      so_asal_is_description:        { type: 'number',  required: true },
      so_asal_created_at:            { type: 'string',  required: true },
      so_item_attribute_name:        { type: 'string',  required: true },
      so_item_attribute_type:        { type: 'string',  required: true },
      options: {
        type: 'array',
        required: false,
        items: {
          so_item_attribute_option_id:            { type: 'number',  required: true },
          so_item_attribute_option_attribute_id:  { type: 'number',  required: true },
          so_item_attribute_option_value:         { type: 'string',  required: true },
          so_item_attribute_option_icon_svg:      { type: 'string',  required: false },
          so_item_attribute_option_display_order: { type: 'number',  required: true },
          so_item_attribute_option_active:        { type: 'number',  required: true },
          so_item_attribute_option_created_at:    { type: 'string',  required: true },
        },
      },
    },
  },
})
